/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Stages_EmptyInputs */

const cs_pipelines_stages_empty = /** @type {(inputs: Pipelines_Stages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné fáze — přidejte první.`)
};

const en_pipelines_stages_empty = /** @type {(inputs: Pipelines_Stages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stages yet — add the first one.`)
};

/**
* | output |
* | --- |
* | "No stages yet — add the first one." |
*
* @param {Pipelines_Stages_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stages_empty = /** @type {((inputs?: Pipelines_Stages_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stages_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stages_empty(inputs)
	return cs_pipelines_stages_empty(inputs)
});